// @mui
import { Box, BoxProps, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
//
import { LoadingButton } from "@mui/lab";
import Image from "~src/components/Image";

// ----------------------------------------------------------------------

const RootStyle = styled(Box)(({ theme }) => ({
  height: "100%",
  display: "flex",
  textAlign: "center",
  alignItems: "center",
  flexDirection: "column",
  justifyContent: "center",
  padding: theme.spacing(2, 2),
}));

// ----------------------------------------------------------------------

interface Props extends BoxProps {
  title: string;
  size?: number;
  img?: string | null;
  actionText?: string;
  actionLoading?: boolean;
  onActionClick?: () => void;
  recommendationHeadline?: string;
  recommendationPoints?: string[];
}

export default function EmptyContent({
  title,
  recommendationHeadline,
  recommendationPoints,
  img,
  actionText,
  actionLoading,
  onActionClick,
  size,
  width,
  height,
  ...other
}: Props) {
  return (
    <RootStyle {...other}>
      {img !== null && (
        <Image
          disabledEffect
          visibleByDefault
          alt="empty content"
          src={img || "/assets/illustrations/illustration_empty_content.png"}
          sx={{
            height: size || height || 240,
            mb: 3,
            width: size || width,
            borderRadius: "8px",
          }}
        />
      )}

      <Typography variant="h5" gutterBottom>
        {title}
      </Typography>

      {recommendationHeadline &&
        recommendationPoints &&
        recommendationPoints.length > 0 && (
          <>
            <Typography>{recommendationHeadline}</Typography>
            <ul style={{ textAlign: "left", paddingLeft: 20 }}>
              {recommendationPoints.map((point, index) => (
                <li key={index}>
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    {point}
                  </Typography>
                </li>
              ))}
            </ul>
          </>
        )}

      {actionText && (
        <LoadingButton
          sx={{ my: 3 }}
          variant="contained"
          onClick={onActionClick}
          loading={actionLoading}
        >
          {actionText}
        </LoadingButton>
      )}
    </RootStyle>
  );
}
